import { NAVBAR_LINK } from "@/utils/enum";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Skeleton,
  Stack,
  Typography
} from "@mui/material";
import Image from "next/image";
import { useState } from "react";
import {
  closeButtonSx,
  descSx,
  dialogPaperSx,
  faqLinkSx,
  installButtonSx,
  skeletonSx,
  titleSx
} from "./ButtonInstallPWA.styles";

interface Props {
  openModal: boolean;
  handleClose: () => void;
  handleInstall: () => void;
}

export const Title = ({ handleClose }: { handleClose: () => void }) => {
  return (
    <DialogTitle sx={{ paddingInline: 2, position: "relative" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <IconButton onClick={handleClose} sx={closeButtonSx}>
          <CloseIcon />
        </IconButton>

        <Typography sx={titleSx}>ウラハルアプリをインストール</Typography>
      </Stack>
    </DialogTitle>
  );
};

export const Description = () => {
  return (
    <Stack direction="column" spacing={1}>
      <Typography sx={descSx}>
        これからは、ウラハルをホーム画面に、アプリとしてインストールできます。通知を簡単に受け取ることができるので、メッセージを見逃すことはありません。
      </Typography>

      <Link
        href={NAVBAR_LINK.faq}
        target="_blank"
        rel="noopener noreferrer"
        sx={faqLinkSx}
      >
        詳細を見る
        <OpenInNewIcon sx={{ ml: 0.5, fontSize: 16 }} />
      </Link>
    </Stack>
  );
};

export default function AndroidChormeGuide({
  openModal,
  handleClose,
  handleInstall
}: Props) {
  const [loaded, setLoaded] = useState(false);
  const [fallback, setFallback] = useState(false);

  return (
    <Dialog
      open={openModal}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: dialogPaperSx }}
    >
      {/* Title */}
      <Title handleClose={handleClose} />
      <DialogContent sx={{ p: 2 }}>
        <Stack direction="column" spacing={2}>
          {/* Description */}
          <Description />
          {/* Image */}
          <Box sx={{ width: "100%", mb: 3, position: "relative", height: 250 }}>
            {!loaded && (
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                sx={skeletonSx}
              />
            )}

            {!fallback && (
              <Image
                src="/images/android-pwa.svg"
                alt="PWA Installation Guide"
                onLoadingComplete={() => setLoaded(true)}
                onError={() => {
                  setLoaded(true);
                  setFallback(true);
                }}
                width={0}
                priority
                height={0}
                sizes="70vw"
                style={{
                  width: "100%",
                  minWidth: 200,
                  maxHeight: 250,
                  height: "auto",
                  borderRadius: "16px 16px 0 0"
                }}
              />
            )}
          </Box>

          {/* Install Button */}
          <Button
            variant="contained"
            fullWidth
            startIcon={<FileDownloadIcon />}
            onClick={handleInstall}
            sx={installButtonSx}
          >
            ウラハルアプリをインストール
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
